<template>
  <div>
    <el-upload
      v-show="
        uploadBtnDisplayFlag &&
          !(
            uploadButtonStyle == 2 &&
            uploadFileList.length > 0 &&
            uploadFileList[0].url
          )
      "
      list-type="picture-card"
      :show-file-list="false"
      ref="upload"
      action="#"
      :disabled="uploadDisable"
      :before-upload="beforeUploadFile"
      :on-change="fileTypeOnChange"
      :file-list="uploadFileList"
      :http-request="myUpload"
      :limit="1"
      :on-exceed="maxUploadNum"
      accept=".jpg,.jpeg,.png,.gif"
      :auto-upload="false"
    >
      <el-button
        class="el-upload--picture-card"
        list-type="picture-card"
        slot="trigger"
      >
        <img src="../../assets/backImg.svg" />
      </el-button>
    </el-upload>
    <div
      class="img_div"
      v-if="
        uploadFileList.length > 0 &&
          uploadFileList[0].url
      "
    >
      <div class="mask">
        <h3>
          <!-- 删除 -->
          <i
            v-if="!uploadPreview"
            class="el-icon-delete"
            @click="handleRemove(uploadFileList[0], uploadFileList)"
          ></i>
        </h3>
      </div>
      <img class="imgCSS" :src="uploadFileList[0].url" alt="" />
    </div>
  </div>
</template>

<script>
import qs from "qs";

export default {
  props: {
    uploadFile: {
      type: Object,
      required: true
    },
    uploadButtonStyle: {
      type: Number,
      default: 0
    },
    uploadDisable: {
      type: Boolean,
      default: false
    },
    uploadPreview: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 附件关联代码
      locationCode: "",
      // 上传的文件
      uploadFileList: [],
      // 提交上传文件时的数据
      submitFileData: "",
      // 删除文件的List
      delFileId: [],
      // 上传按钮显示标志
      uploadBtnDisplayFlag: false,
      // 悬浮层可视标志
      popoverVisible: false,
      // 预览可视标志
      dialogVisible: false,
      // 文件url
      imageUrl: ""
    };
  },
  methods: {
    /** 上传超过最大件数后的钩子 */
    maxUploadNum(files, fileList) {
      if (this.uploadButtonStyle == 2) {
        this.$message.error(
          this.$t("uploadAttachment.maxUploadNumCheck") + "1"
        );
      } else {
        this.$message.error(
          this.$t("uploadAttachment.maxUploadNumCheck") + "4！"
        );
      }
    },
    /** 上传前钩子 */
    beforeUploadFile(file) {
      return true;
    },

    /** 手动删除文件 */
    handleRemove(file, uploadFileList) {

      // 进行删除操作
      const index = uploadFileList.findIndex(d => d.uid === file.uid);
      if (index !== -1) {
        if (file.status === "success") {
          // 说明是已经上传的文件，要去数据库中删除
          // 往删除数组中添加数据
          this.delFileId.push(file.fileId);
        }
        // 文件列表删除文件
        uploadFileList.splice(index, 1);
      }
      // 当删除后文件列表中不再有文件时
      if (uploadFileList.length == 0) {
        // 关闭popover悬浮层
        this.popoverVisible = false;
      }
    },

    /** 下载文件方法 */
    downloadFileMethod(file) {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/common/downLoadFile?path=" + file.url;
      this.$http
        .get(url, { responseType: "blob" })
        .then(response => {
          const blob = new Blob([response.data]);
          if (blob.size == 0) {
            this.$message.error("文件不存在，请联系管理员！");
            loading.close();
          } else {
            // 替换真实文件名
            const fileName = file.name;
            //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
            //IE10以上支持blob，但是依然不支持download
            if ("download" in document.createElement("a")) {
              //支持a标签download的浏览器
              const link = document.createElement("a"); //创建a标签
              link.download = fileName; //a标签添加属性
              link.style.display = "none";
              link.href = URL.createObjectURL(blob);
              document.body.appendChild(link);
              link.click(); //执行下载
              URL.revokeObjectURL(link.href); //释放url
              document.body.removeChild(link); //释放标签
            } else {
              navigator.msSaveBlob(blob, fileName);
            }
            loading.close();
          }
        })
        .catch(err => {
          this.$message.error("文件下载失败，请联系管理员！");
          loading.close();
        });
    },


    /** 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用 */
    fileTypeOnChange(file, fileList) {
      if (this.uploadButtonStyle == 2) {
        if (file.raw.type != "image/jpeg" && file.raw.type != "image/png") {
          //   // 图片
          this.$message.error("上传图片只能是 JPG或者PNG 格式!");
          this.uploadFileList = [];
          return;
        }
      }
      // 选择完上传文件
      // 1:pdf  2:图片
      if (file.status === "ready") {
        // 判断文件的大小
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
          this.$message.error(this.$t("newsAnncmnt.fileSizeCheck"));
          return;
        }

        // 同名文件禁止上传,同时排除自身文件
        const index = fileList.findIndex(
          d => d.name === file.name && d.uid !== file.uid
        );
        if (index === -1) {
          // 说明不重名
          // let thisFileType = '0';
          // if(file.raw.type==="application/pdf"){
          //   // 上传的文件是PDF
          //   thisFileType = '1';
          // }else if(file.raw.type==="image/jpeg" || file.raw.type==="image/png" || file.raw.type==="image/gif" ){
          //   // 图片
          //     thisFileType = '2';
          // }else{
          //   // 删除最后一个元素
          //   fileList.pop();
          //   this.$message.error(this.$t('uploadAttachment.uploadTypeCheck'));
          //   return ;
          // }
          // 文件类型 1:pdf  2:图片
          // file.fileType=thisFileType;
          // 回显的URL
          file.url = URL.createObjectURL(file.raw);
          // 放到fileList中
          this.uploadFileList.push(file);
        } else {
          // 重名不能上传
          // 删除最后一个元素
          fileList.pop();
          this.$message.error(this.$t("uploadAttachment.sameFileNameCheck"));
          return;
        }
      }
    },
    init() {
      // locationCode 关联代码
      this.locationCode = this.uploadFile.locationCode;
      // 上传按钮显示标志
      this.uploadBtnDisplayFlag = this.uploadFile.uploadBtnDisplayFlag;

      // 获取文件列表
      // TODO
      // 如果locationCode是""，返回空的数据列表，解决显示上次上传文件的bug
      if (this.locationCode != "") {
        this.getFileList();
      } else {
        this.uploadFileList = [];
      }
    },
    // 重写上传方法，该方法上传几个文件就会走几次
    myUpload(file) {
      console.log("myUpload");
      // 将上传的文件放在files数组中
      this.submitFileData.append("addFiles", file.file);
    },

    /** 同步等待上传到服务器 */
    async submitUploadFile() {
      console.log("submitUpload");
      this.submitFileData = new FormData(); // new formData对象
      // 执行myUpload方法，但是不会请求后，只是添加上传文件到List
      this.$refs.upload.submit();
      // 当前用户id
      this.submitFileData.append("userId", localStorage.getItem("userId"));
      // 关联位置代码
      this.submitFileData.append("locationCode", this.uploadFile.locationCode);
      // 创建用户的ID
      this.submitFileData.append("creatUser", localStorage.getItem("userId"));
      // 删除的fileID
      this.submitFileData.append("delFiles", this.delFileId);
      // 上传文件标识 -- 用于区分支付凭证/公告附件
      this.submitFileData.append("uploadFlag", this.uploadButtonStyle);

      let url = "/api/common/submitUploadFile";
      // const config = { headers: { 'Content-Type': 'multipart/form-data;charset=utf-8' }}
      await this.$http
        .post(url, this.submitFileData)
        .then(res => {
          if (res.data.code === 200) {
            // this.reportPageNo =res.data.data;
            console.log("上传成功");
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    /** 同步等待获取文件列表 */
    async getFileList() {
      console.log("getFileList",this.uploadFile.locationCode);
      let url = "/api/common/getFileList";
      let paramData = {
        // 关联code
        locationCode: this.uploadFile.locationCode,
        uploadFlag: this.uploadButtonStyle
      };
      await this.$http
        .post(url, qs.stringify(paramData))
        .then(res => {
          if (res.data.code === 200) {
            this.uploadFileList = res.data.data;
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    /** 返回上传文件列表 */
    getUploadFileList() {
      return this.uploadFileList;
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped lang="scss">
.img_div {
  // border-radius: 10px;
  display: block;
  position: relative;
  width: 100%;
  max-width: 100%;
  height: 130px;
}

.imgCSS {
  max-width: 100%;
  height: 130px;
  width: 100%;
  // border-radius: 10px;
  display: block;
  cursor: pointer;
}

.mask {
  position: absolute;
  background: rgba(101, 101, 101, 0.6);
  color: #ffffff;
  opacity: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  // border-radius: 10px;
  pointer-events: none;
}
/** 上传按钮的框框1 */
>>> .el-upload--picture-card {
  width: 100%;
  height: 130px;
  border: none;
  // background-image: "@/assets/backImg.svg";
}
/** 上传按钮的框框1 */
>>> .el-upload--picture-card1 {
  width: 400px;
  height: 130px;
  border: none;
  // background-image: "@/assets/backImg.svg";
}

.mask h3 {
  text-align: center;
  pointer-events: auto;
}
.img_div:hover .mask {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Common/AsqmsUploadImg.vue